import React from 'react'
import PropTypes from 'prop-types'

import format from '@st-operations/uikit/lib/format.js'
import IconACSizes from '../IconSizes'

import './styles.scss'

// estimated size of the audience in each selected region, shown when there is more than one
const RegionSizes = ({ regions, sizes }) => (
  <If condition={regions?.length > 1}>
    <div className="region-sizes" data-testid="region-sizes">
      <For each="region" of={regions}>
        <p key={region._id} className="region-sizes__region">
          <span className="region-sizes__size">
            <IconACSizes />{' '}
            {Number.isFinite(sizes?.[region._id]) ? format('metric', sizes[region._id]) : '…'}
          </span>
          <span className="region-sizes__name">{region.name}</span>
        </p>
      </For>
    </div>
  </If>
)

RegionSizes.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.shape({ _id: PropTypes.string, name: PropTypes.string })),
  sizes: PropTypes.objectOf(PropTypes.number),
}

RegionSizes.defaultProps = {
  regions: [],
  sizes: {},
}

export default RegionSizes
